import React, { useContext, useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import InputMask from 'react-input-mask';
import NumberFormat from 'react-number-format';
import alert from 'react-s-alert';
import { ModalContext } from 'App';
import useFormValidator from 'useFormValidator';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import { InputTemplate } from 'modules/common/components/inputComponents';
import * as actions from '../actions';
import * as c from '../constant';

function CreateModal({
  validateTaxCreditApplication,
  taxCreditApplication,
  createTaxCredit,
  getTaxCreditList,
  creating,
  history,
}) {
  const setModal = useContext(ModalContext);
  const [formData, setFormData] = useState({
    pin: '',
    amount: '',
  });
  const [showAmount, setShowAmount] = useState(false);

  const validateForm = useFormValidator(formData, {
    pin: 'required|rptax_pin_short',
    amount: 'required|number',
  });

  const handleOnSubmit = (e) => {
    e.preventDefault();

    const args = {
      ...formData,
      amount: _.get(formData, 'amount'),
      land_application_id: _.get(taxCreditApplication, 'id'),
    };

    createTaxCredit(args, () => {
      setModal({ isOpen: false });
      getTaxCreditList();
      history.push('/rpt/land/land-settings/tax-credit/');
    });
  };

  const onChange = (e) => {
    if (showAmount) {
      setShowAmount(false);
    }
    return setFormData({
      amount: '',
      [e.target.name]:
        e.target.type === 'checkbox' ? e.target.checked : e.target.value,
    });
  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  useEffect(() => {
    validateForm.validate();
  }, [Object.values(formData).join(',')]);

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <label className="px-3">
            Search for a PIN first before you can proceed.
          </label>
          <div className="col-12">
            <InputTemplate
              // key={i}
              title="Search PIN"
              htmlFor="pin"
              labelClassName="form-label"
              containerClassName=""
              formValidatorMsg={validateForm.renderMessage('pin')}
              placeholder="PIN"
              className="full-input"
              type="text"
              name="pin"
              id="pin"
              actionButtonContainerClass="border"
              withActionButton={() => {
                return (
                  <button
                    type="button"
                    className="btn px-2 font-weight-bold"
                    onClick={() =>
                      validateTaxCreditApplication(
                        { pin: _.get(formData, 'pin') },
                        () => {
                          alert.success(
                            'Your application was successfully validated!'
                          );
                          setShowAmount(true);
                        }
                      )
                    }
                  >
                    Search
                  </button>
                );
              }}
              withCustomInputComponent={() => (
                <InputMask
                  className="form-control"
                  mask="999-99-999-999-999"
                  alwaysShowMask
                  type="text"
                  name="pin"
                  onChange={onChange}
                  value={_.get(formData, 'pin')}
                />
              )}
            />
          </div>
          {showAmount && (
            <div className="col-12">
              <InputTemplate
                title="Amount"
                labelClassName="form-label"
                formValidatorMsg={validateForm.renderMessage('amount')}
                withCustomInputComponent={() => (
                  <NumberFormat
                    name="amount"
                    id="amount"
                    placeholder="PHP 0.00"
                    className="form-control"
                    onValueChange={(values) => {
                      const { floatValue } = values;
                      setFormData(() => ({
                        ...formData,
                        amount: floatValue >= 0 ? floatValue : '',
                      }));
                    }}
                    isNumericString
                    thousandSeparator
                    allowNegative
                    allowLeadingZeros
                    displayType="input"
                    prefix="PHP "
                    value={_.get(formData, 'amount')?.toString()}
                  />
                )}
              />
            </div>
          )}
        </div>
        <div className="d-flex justify-content-center">
          <button
            disabled={creating || !validateForm.response.is_passed}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary mr-3"
          >
            <span className="font-weight-bold">
              {creating ? <i className="fa fa-spin fa-spinner" /> : `Submit`}
            </span>
          </button>
          <button
            disabled={creating}
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

CreateModal.propTypes = {
  getTaxCreditList: PropTypes.instanceOf(Function).isRequired,
  createTaxCredit: PropTypes.instanceOf(Function).isRequired,
  validateTaxCreditApplication: PropTypes.instanceOf(Function).isRequired,
  taxCreditApplication: PropTypes.instanceOf(Object).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  creating: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ api }) => ({
  taxCreditApplication: _.get(api, `${c.VALIDATE_TAX_CREDIT}.item`) || [],
  creating: api.loading.indexOf(c.CREATE_TAX_CREDIT) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(CreateModal);
